module.exports = __webpack_public_path__ + "img/image_signing03@2x.97cdd841.png";